<template>
  <el-dialog title="设置条件" :visible.sync="show" append-to-body width="1024px">
    <div class="gui-condition-preview" title="SQL预览区域">
      <div v-html="html"></div>
      <p v-if="!html">SQL预览区域</p>
    </div>
    <gui-condition-item v-for="(c, i) in conditions" :key="c.key" v-bind="c" ref="items" :metaTables="metaTables" @change="calc" @close="removeCondition(i)"></gui-condition-item>
    <div slot="footer">
      <el-button size="mini" icon="el-icon-add" @click="addCondition" type="primary" style="float:left;">添加条件</el-button>
      <el-button size="mini" @click="show = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="save">保 存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getKey } from '@/util'
import GuiConditionItem from './GuiConditionItem'

//TODO
// 1. 根据不同的运算符处理值
// 2. 判断括号
export default {
  name: 'gui-condition-list',
  components: {
    GuiConditionItem
  },
  data () {
    return {
      show: false,
      metaTables: [],
      conditions: [],
      html: '',
      sql: ''
    }
  },
  methods: {
    open (metaTables, conditions) {
      if (conditions && conditions.length) {
        conditions.forEach((c) => { c.key = getKey() })
      } else {
        conditions = [{ key: getKey() }]
      }

      this.metaTables = metaTables
      this.conditions = conditions
      this.show = true

      this.$nextTick(() => {
        this.calc()
      })
    },
    addCondition () {
      this.conditions.push({ key: getKey() })
    },
    removeCondition (index) {
      this.conditions.splice(index, 1)
      this.calc()
    },
    calc () {
      let result = this.getSql(this.getCondition())
      this.html = result.html
      this.sql = result.html
    },
    getCondition () {
      let conditions = []
      for (let item of this.$refs.items) {
        let f = item.form
        if (!f.table || !f.column || !f.operator || (f.operatorType !== 'none' && !f.value)) {
          break
        }

        conditions.push(f)

        if (!f.combine) {
          break
        }
      }
      return conditions
    },
    getSql (conditions, tableAliasMap, leftEscapeChar, rightEscapeChar) {
      conditions = conditions || []
      tableAliasMap = tableAliasMap || {}
      leftEscapeChar = leftEscapeChar || ''
      rightEscapeChar = rightEscapeChar || ''

      let html = ''
      let sql = ''
      let prevCombine = ''
      for (let f of conditions) {
        if (prevCombine) {
          html += ` <span>${prevCombine}</span> `
          sql += ` ${prevCombine} `
        }

        let alias = tableAliasMap[f.table] || f.table
        if (f.operatorType === 'none') {
          html += `${f.leftBracket}${leftEscapeChar}${alias}${rightEscapeChar}.${leftEscapeChar}${f.column}${rightEscapeChar} <span>${f.operator}</span>${f.rightBracket}`
          sql += `${f.leftBracket}${leftEscapeChar}${alias}${rightEscapeChar}.${leftEscapeChar}${f.column}${rightEscapeChar} ${f.operator}${f.rightBracket}`
        } else {
          html += `${f.leftBracket}${leftEscapeChar}${alias}${rightEscapeChar}.${leftEscapeChar}${f.column}${rightEscapeChar} <span>${f.operator}</span> ${f.value}${f.rightBracket}`
          sql += `${f.leftBracket}${leftEscapeChar}${alias}${rightEscapeChar}.${leftEscapeChar}${f.column}${rightEscapeChar} ${f.operator} ${f.value}${f.rightBracket}`
        }

        prevCombine = f.combine
      }

      return {html: html, sql: sql}
    },
    save () {
      this.$emit('change', this.getCondition())
      this.show = false
    }
  }
}
</script>

<style>
.gui-condition-preview{padding:20px 10px;margin-bottom:20px;border:1px solid #ebebeb;background:#fafafa;text-align:center;border-radius:8px;}
.gui-condition-preview span{color:blue;}
.gui-condition-preview p{color:#333;}
</style>
